var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [
              _vm._v(" Dayforce 101\n                        "),
              _c(
                "div",
                {
                  staticClass: "col-12 col-sm-12 col-md-2 col-lg-2 pull-right"
                },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        name: "categoryId",
                        id: "categoryId",
                        label: "text",
                        filterable: false,
                        options: _vm.categoryArr,
                        placeholder: "Select Category"
                      },
                      on: {
                        change: _vm.changedValue,
                        input: function($event) {
                          return _vm.changedCategoryFor()
                        },
                        search: _vm.onSearchCategory
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _c("div", { staticClass: "d-center" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(option.text) +
                                    "\n                                    "
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "selected-option",
                          fn: function(option) {
                            return [
                              _c("div", { staticClass: "selected d-center" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(option.text) +
                                    "\n                                    "
                                )
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.categoryId,
                        callback: function($$v) {
                          _vm.categoryId = $$v
                        },
                        expression: "categoryId"
                      }
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                                    Search Parent Category...\n                                "
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 float-l width-full" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "forms-policy-main-section col-12 float-l" },
            [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm._l(_vm.dayfoceDocList, function(text, index) {
                    return [
                      _c(
                        "div",
                        { staticClass: "forms-detail-main col-12 float-l" },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              (index + 1) % 2 == 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-right"
                                      },
                                      [
                                        _c("img", {
                                          attrs: { src: text.image_path }
                                        })
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              (index + 1) % 2 != 0
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "left-policy-img col-12 col-sm-5 col-md-5 col-lg-5 pull-left"
                                      },
                                      [
                                        _c("img", {
                                          attrs: { src: text.image_path }
                                        })
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "right-policy-text col-12 col-sm-7 col-md-7 col-lg-7 pull-left"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "heading-text-20 line-height-22 color-red font-text-bold-mont ucase"
                                    },
                                    [_vm._v(" " + _vm._s(text.title) + " ")]
                                  ),
                                  _vm._v(" "),
                                  _c("p", {
                                    directives: [
                                      {
                                        name: "linkified",
                                        rawName: "v-linkified:options",
                                        value: { className: "internal-link" },
                                        expression:
                                          "{ className: 'internal-link' }",
                                        arg: "options"
                                      },
                                      {
                                        name: "linkified",
                                        rawName: "v-linkified"
                                      }
                                    ],
                                    staticClass:
                                      "dayforce-right-title heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30",
                                    domProps: {
                                      innerHTML: _vm._s(text.description)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    directives: [
                                      {
                                        name: "linkified",
                                        rawName: "v-linkified:options",
                                        value: { className: "internal-link" },
                                        expression:
                                          "{ className: 'internal-link' }",
                                        arg: "options"
                                      },
                                      {
                                        name: "linkified",
                                        rawName: "v-linkified"
                                      }
                                    ],
                                    staticClass:
                                      "heading-text-16 line-height-20 color-333333 font-text-semi-medium-mont mb-30",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        text.contact_description
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "benefit-links-section-left-1 col-12"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          _vm._l(text.button_array, function(
                                            btn,
                                            index
                                          ) {
                                            return [
                                              _c(
                                                "p",
                                                [
                                                  btn.button_document != ""
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href: "#",
                                                              id: "id" + index
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.getSignedUrlPath(
                                                                  btn.button_document
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                            " +
                                                                _vm._s(
                                                                  btn.button_title
                                                                ) +
                                                                "\n                                                                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  btn.button_url != ""
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "hvr-sweep-to-right-blue",
                                                            attrs: {
                                                              href:
                                                                btn.button_url,
                                                              target: "_blank"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                                            " +
                                                                _vm._s(
                                                                  btn.button_title
                                                                ) +
                                                                "\n                                                                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dayforce-main-section col-12 float-l" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {},
                [
                  _vm._l(_vm.dayforceList, function(text, index) {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-12 col-md-6 col-lg-6 float-l"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "daygorce-detail-inner width-full float-l"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "hover-home-eefect float-l width-full"
                                },
                                [
                                  text.video_url != ""
                                    ? [
                                        _c("iframe", {
                                          staticClass: "width-full",
                                          attrs: {
                                            width: "560",
                                            height: "300",
                                            src: text.video_url,
                                            frameborder: "0",
                                            allow:
                                              "accelerometer; encrypted-media; gyroscope; picture-in-picture",
                                            allowfullscreen: ""
                                          }
                                        })
                                      ]
                                    : [
                                        _c(
                                          "video",
                                          {
                                            staticClass: "width-full",
                                            attrs: {
                                              width: "560",
                                              height: "300",
                                              controls: "controls",
                                              preload: "metadata"
                                            }
                                          },
                                          [
                                            _c("source", {
                                              attrs: {
                                                src: text.video_path + "#t=0.5",
                                                type: "video/mp4"
                                              }
                                            })
                                          ]
                                        )
                                      ]
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont"
                                },
                                [_vm._v(" " + _vm._s(text.video_title) + " ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"
                                },
                                [_vm._v(" " + _vm._s(text.description) + " ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "btm-video-link width-full float-l"
                                },
                                [
                                  text.video_url != ""
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "heading-text-164 font-text-semi-medium-mont",
                                            attrs: {
                                              href: text.video_url,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(" Click here to view video ")]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "heading-text-164 font-text-semi-medium-mont",
                                            attrs: {
                                              href: text.video_path,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(" Click here to view video ")]
                                        )
                                      ]
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      (index + 1) % 2 == 0
                        ? [
                            _c("div", {
                              staticClass: "clearfix float-l width-full"
                            })
                          ]
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d301313a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d301313a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DayForce101.vue
// module id = null
// module chunks = 